export const translations = {
  'sv': {
    newMessage: 'Nytt meddelande',
    toggleButtonOn: 'Visa detaljer',
    toggleButtonOff: 'Dölj detaljer',
    showMoreLabel: 'Visa mer',
  },
  'en': {
    newMessage: 'New message',
    toggleButtonOn: 'Show details',
    toggleButtonOff: 'Hide details',
    showMoreLabel: 'Show more',
  },
  'da': {
    newMessage: 'Ny besked',
    toggleButtonOn: 'Vis detaljer',
    toggleButtonOff: 'Skjul detaljer',
    showMoreLabel: 'Vis mere',
  },
  'no': {
    newMessage: 'Ny melding',
    toggleButtonOn: 'Vis detaljer',
    toggleButtonOff: 'Skjul detaljer',
    showMoreLabel: 'Vis mer',
  },
  'fi': {
    newMessage: 'Uusi viesti',
    toggleButtonOn: 'Näytä tiedot',
    toggleButtonOff: 'Piilota tiedot',
    showMoreLabel: 'Näytä lisää',
  },
  'de': {
    newMessage: 'Neue Nachricht',
    toggleButtonOn: 'Details anzeigen',
    toggleButtonOff: 'Details ausblenden',
    showMoreLabel: 'Mehr anzeigen',
  },
  'zh': {
    newMessage: '新消息',
    toggleButtonOn: '显示详情',
    toggleButtonOff: '隐藏详情',
    showMoreLabel: '显示更多',
  },
  'it': {
    newMessage: 'Nuovo messaggio',
    toggleButtonOn: 'Mostra dettagli',
    toggleButtonOff: 'Nascondi dettagli',
    showMoreLabel: 'Mostra di più',
  },
  'nl': {
    newMessage: 'Nieuw bericht',
    toggleButtonOn: 'Toon details',
    toggleButtonOff: 'Verberg details',
    showMoreLabel: 'Meer tonen',
  },
  'tr': {
    newMessage: 'Yeni mesaj',
    toggleButtonOn: 'Detayları göster',
    toggleButtonOff: 'Detayları gizle',
    showMoreLabel: 'Daha fazla göster',
  },
  'pt': {
    newMessage: 'Nova mensagem',
    toggleButtonOn: 'Mostrar detalhes',
    toggleButtonOff: 'Ocultar detalhes',
    showMoreLabel: 'Mostrar mais',
  },
  'pl': {
    newMessage: 'Nowa wiadomość',
    toggleButtonOn: 'Pokaż szczegóły',
    toggleButtonOff: 'Ukryj szczegóły',
    showMoreLabel: 'Pokaż więcej',
  },
  'pt-BR': {
    newMessage: 'Nova mensagem',
    toggleButtonOn: 'Mostrar detalhes',
    toggleButtonOff: 'Ocultar detalhes',
    showMoreLabel: 'Mostrar mais',
  }
};
